export const SCRAPE_FETCH_ENGINES = ['fetch', 'playwright'];
export const SCRAPE_FETCH_ENGINE_LABELS = {
    fetch: 'Static HTML (fetch)',
    playwright: 'Browser (Playwright)',
};
//# sourceMappingURL=scrapeEngine.js.map